/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'multiply-sign': {
    width: 12,
    height: 12,
    viewBox: '0 0 10 10',
    data: '<line pid="0" x2=".6em" y2=".6em" stroke-linecap="round" stroke-width="2" _stroke="currentColor"/><line pid="1" x1=".6em" y2=".6em" stroke-linecap="round" stroke-width="2" _stroke="currentColor"/>'
  }
})
